import React from "react";

const UnbanUser = () => {
  return <div>UnbanUser</div>;
};

export default React.memo(UnbanUser);
